// Canvas 指纹
function getCanvasFingerprint() {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  // 绘制文字
  ctx.textBaseline = 'top';
  ctx.font = '16px Arial';
  ctx.fillStyle = '#f60';
  ctx.fillRect(125, 1, 62, 20);
  ctx.fillStyle = '#069';
  ctx.fillText('FingerprintJS', 2, 15);
  // 读取像素数据
  const dataURL = canvas.toDataURL();
  return dataURL;
}

// WebGL 指纹
function getWebGLFingerprint() {
  const canvas = document.createElement('canvas');
  const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
  if (!gl) return '';
  const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
  const vendor = gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL);
  const renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
  return vendor + '~' + renderer;
}

// 简易 MurmurHash3 实现（示例，可替换为更成熟的库）
function murmurhash3_32_gc(key, seed = 31) {
  let remainder = key.length & 3;
  let bytes = key.length - remainder;
  let h1 = seed;
  let c1 = 0xcc9e2d51,
    c2 = 0x1b873593;
  let i = 0,
    k1 = 0;

  while (i < bytes) {
    k1 =
      (key.charCodeAt(i) & 0xff) |
      ((key.charCodeAt(++i) & 0xff) << 8) |
      ((key.charCodeAt(++i) & 0xff) << 16) |
      ((key.charCodeAt(++i) & 0xff) << 24);
    ++i;
    k1 = ((k1 & 0xffff) * c1 + ((((k1 >>> 16) * c1) & 0xffff) << 16)) & 0xffffffff;
    k1 = (k1 << 15) | (k1 >>> 17);
    k1 = ((k1 & 0xffff) * c2 + ((((k1 >>> 16) * c2) & 0xffff) << 16)) & 0xffffffff;

    h1 ^= k1;
    h1 = (h1 << 13) | (h1 >>> 19);
    const h1b = ((h1 & 0xffff) * 5 + ((((h1 >>> 16) * 5) & 0xffff) << 16)) & 0xffffffff;
    h1 = (h1b & 0xffff) + 0x6b64 + ((((h1b >>> 16) + 0xe654) & 0xffff) << 16);
  }

  k1 = 0;
  if (remainder > 0) {
    for (let j = remainder; j > 0; --j) {
      k1 ^= (key.charCodeAt(i + j - 1) & 0xff) << ((j - 1) * 8);
    }
    k1 = ((k1 & 0xffff) * c1 + ((((k1 >>> 16) * c1) & 0xffff) << 16)) & 0xffffffff;
    k1 = (k1 << 15) | (k1 >>> 17);
    k1 = ((k1 & 0xffff) * c2 + ((((k1 >>> 16) * c2) & 0xffff) << 16)) & 0xffffffff;
    h1 ^= k1;
  }

  h1 ^= key.length;
  // fmix
  h1 ^= h1 >>> 16;
  h1 = ((h1 & 0xffff) * 0x85ebca6b + ((((h1 >>> 16) * 0x85ebca6b) & 0xffff) << 16)) & 0xffffffff;
  h1 ^= h1 >>> 13;
  h1 = ((h1 & 0xffff) * 0xc2b2ae35 + ((((h1 >>> 16) * 0xc2b2ae35) & 0xffff) << 16)) & 0xffffffff;
  h1 ^= h1 >>> 16;

  return (h1 >>> 0).toString(16);
}

// 最终整合
export async function generateFingerprint() {
  const components = [];
  // Navigator
  components.push(navigator.userAgent);
  components.push(navigator.platform);
  components.push(navigator.languages.join(','));
  // Screen
  components.push(screen.width + 'x' + screen.height + 'x' + screen.colorDepth);
  components.push(window.devicePixelRatio.toString());
  // Timezone
  components.push(Intl.DateTimeFormat().resolvedOptions().timeZone || '');
  // Canvas / WebGL
  components.push(getCanvasFingerprint());
  components.push(getWebGLFingerprint());
  // 更多组件可按需添加...

  const raw = components.join('||');
  const hash = murmurhash3_32_gc(raw);
  return hash;
}

// 使用示例
// generateFingerprint().then(fp => console.log('Browser Fingerprint:', fp));
